import { UserRound } from 'lucide-react';
import type { OffOrgNavSection } from '@/config/offOrgNavigation';

/**
 * The account sidebar (docs/NAVIGATION.md "Off-org navigation"): the nav for
 * per-user pages that live outside `/org/:orgId` (`/profile`, …), shown by
 * `AppLayout navigation="account"` instead of the org sidebar, whose links
 * need a selected organization. Paths are absolute app paths (not org-relative).
 * Add a per-user page here with one line.
 */
export const ACCOUNT_NAV_SECTIONS: OffOrgNavSection[] = [
  { items: [{ labelKey: 'nav.account.profile', href: '/profile', icon: UserRound }] },
];
